import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Hammer: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M17.3207 8.4088L3.44617 19.6352C3.1881 19.844 3.12298 20.2108 3.29343 20.4957L3.57279 20.9626C3.75316 21.2641 4.13652 21.3738 4.44911 21.2135L20.2066 13.1317M17.3207 8.4088L17.227 8.3837M17.3207 8.4088L20.2066 13.1317M17.227 8.3837L16.283 3.10246C16.1781 2.51512 16.8384 2.09621 17.325 2.44139L21.8995 5.68606M17.227 8.3837L21.8995 5.68606M21.8995 5.68606L25.0208 10.3338C25.0946 10.4437 25.134 10.5731 25.134 10.7055L25.134 10.8113M20.2066 13.1317L24.7064 16.9138C25.1693 17.3028 25.8695 16.9242 25.7972 16.3238L25.134 10.8113M20.2066 13.1317L25.134 10.8113"
      stroke="#B4EB56"
      strokeWidth="2"
    />
    <path
      d="M17 29.3333V24.6667C17 24.2985 17.2985 24 17.6667 24H28.3333C28.7015 24 29 24.2985 29 24.6667V29.3333C29 29.7015 28.7015 30 28.3333 30H17.6667C17.2985 30 17 29.7015 17 29.3333Z"
      stroke="#B4EB56"
      strokeWidth="2"
    />
  </SvgIcon>
);

export const HammerDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M17.3207 8.4088L3.44617 19.6352C3.1881 19.844 3.12298 20.2108 3.29343 20.4957L3.57279 20.9626C3.75316 21.2641 4.13652 21.3738 4.44911 21.2135L20.2066 13.1317M17.3207 8.4088L17.227 8.3837M17.3207 8.4088L20.2066 13.1317M17.227 8.3837L16.283 3.10246C16.1781 2.51512 16.8384 2.09621 17.325 2.44139L21.8995 5.68606M17.227 8.3837L21.8995 5.68606M21.8995 5.68606L25.0208 10.3338C25.0946 10.4437 25.134 10.5731 25.134 10.7055L25.134 10.8113M20.2066 13.1317L24.7064 16.9138C25.1693 17.3028 25.8695 16.9242 25.7972 16.3238L25.134 10.8113M20.2066 13.1317L25.134 10.8113"
      stroke="#090C18"
      strokeWidth="2"
    />
    <path
      d="M17 29.3333V24.6667C17 24.2985 17.2985 24 17.6667 24H28.3333C28.7015 24 29 24.2985 29 24.6667V29.3333C29 29.7015 28.7015 30 28.3333 30H17.6667C17.2985 30 17 29.7015 17 29.3333Z"
      stroke="#090C18"
      strokeWidth="2"
    />
  </SvgIcon>
);
